import { InjectionToken, Injector, Type } from '@angular/core';

export class ServiceLocator {
    private static injector: Injector;

    public static init(injector: Injector) {
        this.injector = injector;
    }

    public static get<TService>(token: Type<TService> | InjectionToken<TService>): any {
        return this.injector.get<TService>(token);
    }
}
